import { Divider, Stack, Typography, Box } from '@mui/material'
import { ITender } from 'types/tender'
import { TenderGeneralInfo } from './tender-general-info'
import { useTranslation } from 'react-i18next'
import { useSubmissionEvaluationsQuery } from 'services/submissions/submission-evaluation'
import { ContestResultEvaluationSubmissions } from './contest-result-evaluation-submissions'
import { useQueryState } from 'react-router-use-location-state'
import { Loading } from 'components/Loading'
import { Error } from 'components/Error'
import { ESubmissionEvaluationStatus } from 'types/submissions/submissions-evaluation'
import { TenderContestResultTable } from './tender-contest-result-table'

const horizontalDivider = (
  <Divider
    sx={{
      borderStyle: 'dashed',
      borderWidth: '1.5px',
      flexGrow: 1,
      alignSelf: 'center',
    }}
    flexItem
  />
)

type Props = {
  tender: ITender
}

export const TenderContestResult = ({ tender }: Props) => {
  const { t } = useTranslation()

  const [page, setPage] = useQueryState('page', 0)
  const rowsPerPage = 10

  const status: string[] = [
    ESubmissionEvaluationStatus.CONFIRMED,
    ESubmissionEvaluationStatus.DECLINED,
    ESubmissionEvaluationStatus.FINISHED,
  ]

  const args = {
    page,
    size: rowsPerPage,
    tenderId: tender.id,
    statuses: status,
  } as const

  const {
    data: submissionEvaluations,
    isLoading,
    isError,
  } = useSubmissionEvaluationsQuery(args, {
    skip: !tender.id,
    refetchOnMountOrArgChange: true,
  })

  if (isLoading) return <Loading fullPage={false} />
  if (isError) return <Error />

  return (
    <Stack spacing={2}>
      <TenderGeneralInfo tender={tender} />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
        divider={horizontalDivider}
      >
        <Typography variant="body2" fontWeight="bold">
          {t('lot-number')}
        </Typography>
        <Typography variant="body2" fontWeight="bold">
          {`LOT${tender.lot.number}`}
        </Typography>
      </Stack>
      {submissionEvaluations && (
        <>
          <Divider flexItem />
          <TenderContestResultTable data={submissionEvaluations.items} />
        </>
      )}
      <Divider flexItem />
      <Box sx={{ maxWidth: '100%' }}>
        {submissionEvaluations &&
          submissionEvaluations?.items.length > 0 &&
          submissionEvaluations?.items.map((sub) => {
            return (
              <ContestResultEvaluationSubmissions
                key={sub.submissionId}
                sub={sub}
                tender={tender}
              />
            )
          })}
      </Box>
    </Stack>
  )
}
